/**
 * @generated SignedSource<<616798a1110cc774dae21ed2927108b8>>
 * @relayHash 57b95301110b1ad68d0a5f67863629a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 643bd0ccc6a2192e79c1160bc158280aad318d9a2af7724412f89610c142cba0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessCalendarQuery } from './src_jiraBusinessCalendarQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "643bd0ccc6a2192e79c1160bc158280aad318d9a2af7724412f89610c142cba0",
    "metadata": {},
    "name": "src_jiraBusinessCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
